<template>
  <div v-loading="isLoging">
    <el-dialog
      :title=title
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div style="margin-top: 1rem;margin-right: 100px;">
        <el-form ref="shipFormRef" :rules="rules" :model="form" label-width="140px" >
          <el-form-item label="船舶名称" prop="shipName">
            <el-input v-model="form.shipName" clearable :disabled="form.shipId"></el-input>
          </el-form-item>
          <el-form-item label="CN" prop="cn">
            <el-input v-model="form.cn" clearable></el-input>
          </el-form-item>
          <el-form-item label="MMSI" prop="mmsi">
            <el-input v-model="form.mmsi" clearable></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyId">
            <el-select
              v-model="companyId"
              style="width: 100%"
              placeholder="请选择公司"
              @change="changeCompany"
            >
              <el-option v-for="company in deptList" :key="company.companyId" :label="company.companyName" :value="company.companyId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" @click="onSubmit" :loading="dialogLoading" >保存</el-button>
              <el-button @click="close">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "shipEdit",
  props: {},
  computed: {},
  created() {},
  data() {
    return {
      title: '添加船舶',
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      dialogLoading: false,
      form: {
        shipId: null,
        shipName: '',
        companyId: '',
        cn: '',
        mmsi: '',
      },
      companyId: '',
      deptList:{},
      rules: {
        shipName: [{ required: true, message: "请输入船舶名称", trigger: "blur" }],
        companyId: [{ required: true, message: "请选择公司", trigger: "blur" }],
        cn: [{ required: true, message: "请输入CN", trigger: "blur" }],
        mmsi: [{ required: true, message: "请输入mmsi", trigger: "blur" }]
      },
    };
  },
  methods: {
    openDialog: function (data, callback) {
      this.getdeptList()
      this.showDialog = true;
      this.title = '添加船舶'
      this.listChangeCallback = callback;
      if (data != null) {
        this.form.shipId = data.shipId;
        this.form.shipName = data.shipName;
        this.form.companyId = this.companyId = data.companyId
        this.form.cn = data.cn;
        this.form.mmsi = data.cn;
        this.title = '编辑船舶'
      }
    },
    getdeptList(){
      let that = this;
      this.$axios({ method: 'get', url:`/api/company/DropDownList` }).then( res => {
        that.deptList = res.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeCompany(val) {
      this.form.companyId = val
    },
    onSubmit: function () {
      this.dialogLoading = true;
      var that = this;
      this.$refs.shipFormRef.validate(flag => {
        //表单验证通过
        if (flag) {
          if (that.form.shipId) {
            this.$axios({ method: 'post', url:`/api/ship/update`, params: {...this.form} }).then( res => {
              if (res.data.code == 200) {
                that.$message.success('修改成功')
                that.showDialog = false;
                if (that.listChangeCallback != null) {
                  that.listChangeCallback();
                  that.dialogLoading = false;
                }
              } else {
                that.$message.error(res.data.msg)
              }
            }).catch(error => {
              this.dialogLoading = false;
            });
          } else {
            this.$axios({ method: 'post', url:`/api/ship/add`, params: {...this.form} }).then( res => {
              if (res.data.code == 200) {
                that.$message.success('添加成功')
                that.showDialog = false;
                if (that.listChangeCallback != null) {
                  that.listChangeCallback();
                }
              } else {
                that.$message.error(res.data.msg)
              }
              that.dialogLoading = false;
            }).catch(error => {
              this.dialogLoading = false;
            });
          }
        } else {
          that.dialogLoading = false;
          return this.$message.error('请按照格式要求输入数据')
        }
      })
    },
    close() {
      this.form = {
        shipId: null,
        shipName: '',
        companyId: '',
        cn: '',
      }
      this.companyId = ''
      // this.$refs.shipFormRef.resetFields()
      this.showDialog = false;
      this.dialogLoading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/shipEdit.vue